export function createPlugin(Component) {
    return {
        install: function (Vue) {
            Vue.component(Component.options.name, Component);
        },
    };
}
//# sourceMappingURL=registerComponent.js.map